<div [loading]="loading">
	<gob-back [url]="route.get('product-list')"></gob-back>
	<div class="form-content">
		<form class="form-admin-left" #form="ngForm">
			<gob-message [error]="error" [msg]="msg"></gob-message>

			<nav>
			  <div class="nav nav-tabs" id="product-tab">
			    <button class="nav-link active" data-bs-toggle="tab" data-bs-target="#product-info" type="button">Informations</button>
			    <button class="nav-link" data-bs-toggle="tab" data-bs-target="#product-prices" type="button">Tarifs</button>
			    <button class="nav-link" data-bs-toggle="tab" data-bs-target="#product-class" type="button">Classification</button>
			    <button class="nav-link" data-bs-toggle="tab" data-bs-target="#product-stock" type="button">Stocks</button>
			  </div>
			</nav>
			<div class="tab-content" id="nav-tabContent">
			  <div class="tab-pane fade show active" id="product-info">
			  	<gob-product-info [product]="product" [product]="product"></gob-product-info>
			  </div>
			  <div class="tab-pane fade" id="product-prices">
			  	<gob-product-price [product]="product"></gob-product-price>
			  </div>
			  <div class="tab-pane fade" id="product-class">
			  	<gob-product-class [product]="product"></gob-product-class>
			  </div>
			  <div class="tab-pane fade" id="product-stock">
			  	<gob-product-stock [product]="product" [stockRight]="stockRight"></gob-product-stock>
			  </div>
			</div>

			<button scrollTo (click)="update(form)" class="btn green" [disabled]="form.invalid" [disabled]="form.invalid">{{((product.ident)? "Modifier" : "Créer")}}</button>
			<button *ngIf="product.ident" (click)="rm()" class="btn btn-danger">Supprimer</button>
		</form>
		<div class="form-admin-right">
			<!-- Etat du produit -->
			<div class="card">
			  <div class="card-header">
			    <i class="fa-regular fa-satellite-dish"></i> Etat du produit
			  </div>
			  <div class="card-body">
			  	<div class="badge-container">
				  	<span class="badge" [ngClass]="getBadgeClass()">{{product.state | uppercase}}</span>
			  	</div>

          <!-- brouillon -->
          <div class="form-check form-switch mb-3">
            <input class="form-check-input" type="checkbox" (change)="setDraft($event)" id="product-draft" name="isDraft" [checked]="product.state=='draft'"/>
            <label class="form-check-label" for="product-draft">Mode brouillon</label>
          </div>
			  </div>
			</div>

			<!-- Main image -->
			<div class="card">
			  <div class="card-header">
			    <i class="fa-regular fa-image"></i> Image principale
			  </div>
			  <div class="card-body">
          <div *ngIf="mainImage" class="img-container main-image">
            <img [src]="getImage(mainImage)"/>
            <a (click)="rmImage('main')" class="close-image"><i class="fa-sharp fa-regular fa-circle-xmark"></i></a>
          </div>
          <div class="mb-3">
            <label *ngIf="!mainImage" for="img">Ajouter une image principale</label>
            <input class="mt-3" type="file" (change)="onFileSelected($event, 'main')" required id="img" name="mainImg" #img />
          </div>
        </div>
			</div>

			<!-- Gallery images -->
			<div class="card">
				<div class="card-header">
					<i class="fa-regular fa-images"></i> Images de la galerie
				</div>
				<div class="card-body">
					<div *ngIf="galleryImages.length" class="gallery-grid">
							<div *ngFor="let img of galleryImages; index as i" class="gallery-item">
								<img [src]="getImage(img)"/>
								<a (click)="rmImage(null, i)" class="close-image">
								<i class="fa-sharp fa-regular fa-circle-xmark"></i>
								</a>
							</div>
					</div>
					<div class="mb-3">
					<input type="file" (change)="onFileSelected($event, 'gallery')" multiple required #img/>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
